import { Input as InputReact } from './Input';

export const Input = InputReact;
